import "./VenuesBookTimeRange.scss";
import {useTranslation} from "react-i18next";
import {Select} from "antd";
import moment from "moment";
import CustomButton from "../../../components/UI/CustomButton/CustomButton";
import {VenueService} from "../../../services/venue.service";
import React from "react";

interface VenuesBookTimeRangeProps {
    setSelectedStartHour: (value: {id: number, label: string, startDate: any}) => void;
    setSelectedEndHour: (value: {id: number, label: string, endDate: any}) => void;
    selectedStartHour: {id: number, label: string, startDate: any};
    selectedEndHour: {id: number, label: string, endDate: any};
    checkAvailability: () => void;
}

const VenuesBookTimeRange: React.FC<VenuesBookTimeRangeProps> = ({setSelectedStartHour, setSelectedEndHour, selectedStartHour, selectedEndHour, checkAvailability}) => {
    const { Option } = Select;

    const {t} = useTranslation();

    const startHours = VenueService.getStartHours();
    const endHours = VenueService.getEndHours();

    const onChangeStartDateInput = (value: string, allValues: any) => {
        setSelectedStartHour({
            id: Number(allValues.key),
            label: allValues.children,
            startDate: moment(allValues.value).toDate()
        })
    }

    const onChangeEndDateInput = (value: string, allValues: any) => {
        setSelectedEndHour({
            id: Number(allValues.key),
            label: allValues.children,
            endDate: moment(allValues.value).toDate()
        })
    }

    return (
        <div className="venues-book-time-range">
            <div className={"select-time-wrapper"}>
                <div className={"item"}>
                    <p className={"label"}>{t("StartTime")}</p>
                    <Select
                        className={"select-input"}
                        onChange={onChangeStartDateInput}
                        value={moment(selectedStartHour.startDate).format("HH:mm")}
                        optionLabelProp={"label"}
                        variant={"borderless"}
                    >
                        {startHours.map(el => {
                            return (
                                <Option value={el.startDate.toString()} key={el.id}>{el.label}</Option>
                            )
                        })}
                    </Select>
                </div>
                <div className={"item"}>
                    <p className={"label"}>{t("EndTime")}</p>
                    <Select
                        className={"select-input"}
                        onChange={onChangeEndDateInput}
                        value={moment(selectedEndHour.endDate).format("HH:mm")}
                        optionLabelProp={"label"}
                        variant={"borderless"}
                    >
                        {endHours.map(el => {
                            return (
                                <Option value={el.endDate.toString()} key={el.id}>{el.label}</Option>
                            )
                        })}
                    </Select>
                </div>
                <div className={"item btn-wrapper"}>
                    <CustomButton
                        text={t("CheckAvailability")}
                        type={"button"}
                        typeStyle={"fill"}
                        borderRadius={false}
                        functionOnClick={checkAvailability}
                    />
                </div>
            </div>
        </div>
    )
};

export default VenuesBookTimeRange;